<template>
  <v-dialog
    v-model="isOpenTemplateRemoveDialog"
    persistent
    max-width="475px"
    transition="dialog-transition"
  >
    <v-card>
      <v-card-text class="pa-5 text-center">
        <v-icon color="warning" size="60" class="my-3">
          warning
        </v-icon>
        <div ref="text-question" class="title warning--text">
          {{ $t('templates.remove.question') }}
        </div>
        <div ref="text-info">
          {{ $t('templates.remove.text') }}
        </div>   
      </v-card-text>
      <v-card-actions class="pb-5">
        <v-row dense justify="center">
          <v-col cols="4">
            <v-btn
              ref="button-close"
              @click="close()"
              color="primary"
              block
              outlined
            >
              {{ $t('actions.cancel') }}
            </v-btn>
          </v-col>
          <v-col cols="4">
            <v-btn
              ref="button-confirm"
              @click="confirm()"
              color="primary"
              block
              depressed
            >
              {{ $t('actions.remove') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'TemplateRemoveDialog',
  props: {
    type: {
      type: String,
      default: 'email'
    },
  },
  computed: {
    ...mapGetters({
      deteledTemplateId: 'templates/deteledTemplateId',
      isOpenTemplateRemoveDialog: 'templates/isOpenTemplateRemoveDialog',
      isOpenLandingEditor: 'landing/landings/isOpenLandingEditor',
      landingTemplateId: 'landing/landings/landingTemplateId'
    })
  },
  methods: {
    ...mapActions({ removeTemplate: 'templates/removeTemplate' }),
    ...mapMutations({
      setDeteledTemplateId: 'templates/setDeteledTemplateId',
      closeTemplateRemoveDialog: 'templates/closeTemplateRemoveDialog',
      setLandingTemplateId: 'landing/landings/setLandingTemplateId'
    }),
    async confirm() {
      const { deteledTemplateId } = this
      const { success } = await this.removeTemplate({ id: deteledTemplateId })
      if (
        success &&
        this.type === 'landing' &&
        this.isOpenLandingEditor &&
        (this.landingTemplateId === deteledTemplateId)
      ) {
        this.setLandingTemplateId(null)
      }
      this.close()
    },
    close() {
      this.closeTemplateRemoveDialog()
      this.setDeteledTemplateId(null)
    }
  }
}
</script>
